import React, { useEffect, useState } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { IToolboxAvailables } from './common/availableToolboxItems';

interface IProps {
  availables: Array<IToolboxAvailables>
}

export const Toolbox: React.FC<IProps> = ({ availables }) => {
  const [aa, setAA] = useState(availables);
  useEffect(
    () => {
      console.log('ue11');
      setAA(availables);
    },
    [availables]
  );
  if (!availables) return null;
  return (
    <Flex flex={1}>
      <Droppable droppableId="availables355">
        {(provided, snapshot) => {
          return (
            <div
            {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ minHeight: '100%', width: '100%', padding: '12px', border: snapshot.isDraggingOver ? '2px dashed rgb(227, 117, 117)' : '2px solid rgba(255,255,255,0)' }}
            >
              {availables
                .sort((a, b) => {
                  if (a.order < b.order) return -1;
                  return 1;
                })
                .map((x, i) => {
                  return (
                    <Draggable key={`xdropxdrop${i}`} draggableId={`avail${(x || {
                      id: new Date().getTime()
                    }).id}`} index={i+1}>
                      {(provided3, snapshot) => {
                        return (
                          <>
                            <div key={`xdrop${i}`} ref={provided3.innerRef} {...provided3.dragHandleProps} {...provided3.draggableProps} >
                              <Flex flexDirection={'row'} mb={2}>
                                <Box
                                  style={{
                                    marginLeft: `8px`,
                                    background:'white',
                                    border: `1px dashed #717171`,
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    width: '100%',
                                  }}
                                >
                                  <Flex flexDirection={'row'} alignItems={'center'}>
                                    <i className={(x || {}).icon} />
                                    <Flex flexDirection={'column'} ml={2}>
                                      <Text>{(x || {}).name}</Text>
                                    </Flex>
                                  </Flex>
                                </Box>
                              </Flex>
                            </div>
                            {snapshot.isDragging && (
                              <Flex flexDirection={'row'} mb={2}>
                                <Box
                                  style={{
                                    marginLeft: `8px`,
                                    background: 'white',
                                    border: `1px solid #717171`,
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    width: '100%',
                                  }}
                                >
                                  <Flex flexDirection={'column'}>
                                    <Flex flexDirection={'column'}>
                                      <Text>{x.name}</Text>
                                    </Flex>
                                  </Flex>
                                </Box>
                              </Flex>
                            )}
                          </>
                        );
                      }}
                    </Draggable>
                  );
                })}
            </div>
          );
        }}
      </Droppable>
    </Flex>
  );
};
